import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers', {
        url: '/integration-developers',
        redirectTo,
        component: 'companyManageApplicationIntegrationDevelopers',
    });
}

function redirectTo(transition) {
    return transition.injector().getAsync('application').then((application) => {
        if (application.applicationType.slug === 'office-365') {
            return 'company.manage-application.integration-developers.integration-office-365';
        } else {
            return 'company.manage-application.integration-developers.integration';
        }
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/integration-developers.state.js